// removed by extract-text-webpack-plugin
module.exports = {"NtfToast":"socketProvider__NtfToast__VIKFd","Visible":"socketProvider__Visible__kqqoC socketProvider__NtfToast__VIKFd","Hidden":"socketProvider__Hidden__2YnWx socketProvider__NtfToast__VIKFd"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/HOC/socketProvider.css
// module id = 1755
// module chunks = 2